import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { TableRow } from '@mui/material';
import TablePagination from '@mui/material/TablePagination';
import TableCell from 'src/components/Table/TableCell';
import { useTranslation } from 'react-i18next';
import TablePaginationCustom from 'src/components/Table/TablePaginationCustom';
import Table from 'src/components/Table';
import MonthlyReportRow from './MonthlyReportRow';
import useStyles from './styles';

if (!process.env.REACT_APP_TABLE_SIZE) {
  console.error(
    'REACT_APP_TABLE_SIZE variable not loaded properly. Check your .env file please!'
  );
}

const Tbody = ({ bureauReportList }) =>
  bureauReportList.map(bureauReport => (
    <MonthlyReportRow key={bureauReport.id} {...bureauReport} />
  ));

const MonthlyReportTable = ({
  className,
  bureauReportList,
  count,
  page,
  handleChangePage,
  loading,
  ...rest
}) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  const theads = useMemo(
    () => () => (
      <TableRow>
        <TableCell
          variant="head"
          key="date"
          sx={{ width: '25%' }}
          align="center"
        >
          {t('BUREAU_REPORTS.PERIOD')}
        </TableCell>

        <TableCell
          variant="head"
          key="contractsUpToDate"
          align="center"
          sx={{ width: '25%' }}
        >
          {t('BUREAU_REPORTS.CONTRACTS_UP_TO_DATE')}
        </TableCell>

        <TableCell
          variant="head"
          key="contractsWithDebt"
          align="center"
          sx={{ width: '25%' }}
        >
          {t('BUREAU_REPORTS.CONTRACTS_WITH_DEBT')}
        </TableCell>

        <TableCell
          variant="head"
          key="actions"
          align="right"
          sx={{ width: '25%' }}
        />
      </TableRow>
    ),
    [classes, t]
  );

  const tbody = useMemo(
    () => () => <Tbody bureauReportList={bureauReportList} />,
    [bureauReportList]
  );

  const pagination = useMemo(
    () => () => (
      <TablePagination
        rowsPerPageOptions={[]}
        component="div"
        count={count}
        rowsPerPage={+process.env.REACT_APP_TABLE_SIZE}
        page={page}
        onPageChange={handleChangePage}
        ActionsComponent={TablePaginationCustom}
        labelDisplayedRows={({ from, to, count: c }) => {
          return `${from}-${to} ${t('COMMON.OF')} ${c}`;
        }}
      />
    ),
    [page, bureauReportList, count, handleChangePage, t]
  );

  return (
    <Table
      {...rest}
      variant="outlined"
      tbody={tbody}
      theads={theads}
      pagination={pagination}
      loading={loading}
    />
  );
};

MonthlyReportTable.propTypes = {
  className: PropTypes.string,
  bureauReportList: PropTypes.array.isRequired,
  count: PropTypes.number,
  page: PropTypes.number,
  handleChangePage: PropTypes.func,
  loading: PropTypes.bool
};

MonthlyReportTable.defaultProps = {
  count: 0
};

Tbody.propTypes = {
  bureauReportList: PropTypes.array.isRequired
};

export default MonthlyReportTable;
